import React from 'react';
import {TripBoardsModalReduxProvider} from '@homeaway/react-trip-board-button';
import Experiment from '@homeaway/react-experiment';
import {HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} from '../../abacus/experiments';
import LoginExperience from '../LoginExperience/LoginExperience';

export default function TripBoardsProviderContainer({
    siteName,
    isLoggedIn,
    locale,
    brand,
    graphqlQuery,
    setUserLoggedIn,
    adultsCount,
    childrenCount,
    endDate,
    petIncluded,
    startDate
}) {
    const tripBoardProviderParams = {
        graphqlQuery,
        adultsCount,
        childrenCount,
        endDate,
        petIncluded,
        startDate
    };

    return (
        <Experiment name={HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} deferLogging>
            {({On, Off}) => (
                <React.Fragment>
                    <On>
                        <TripBoardsModalReduxProvider
                            siteName={siteName}
                            {...tripBoardProviderParams}
                            isLoggedIn={isLoggedIn}
                            autosave
                            {...!isLoggedIn && {
                                renderInitialModal: (onComplete, onClose, isOpen) =>
                                    isOpen && (
                                        <LoginExperience
                                            modalMode
                                            locale={locale}
                                            actionLocation="heartButtonLogin"
                                            site={siteName}
                                            siteName={brand}
                                            onClose={onClose}
                                            onSuccess={onComplete}
                                            context="savetripboard"
                                            setUserLoggedIn={setUserLoggedIn}
                                        />
                                    )
                            }}
                        />
                    </On>
                    <Off>
                        <TripBoardsModalReduxProvider
                            siteName={siteName}
                            {...tripBoardProviderParams}
                            isLoggedIn={isLoggedIn}
                            autosave
                        />
                    </Off>
                </React.Fragment>
            )}
        </Experiment>
    );
}
